/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNavFilters_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterDeliveryOptions_viewer">;
    readonly " $refType": "BuyRespTopNavFilters_viewer";
};
export type BuyRespTopNavFilters_viewer$data = BuyRespTopNavFilters_viewer;
export type BuyRespTopNavFilters_viewer$key = {
    readonly " $data"?: BuyRespTopNavFilters_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyRespTopNavFilters_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNavFilters_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'fedfd0b7be73b460c28b6449bd058cf6';
export default node;
